import { render, staticRenderFns } from "./confirm-modal.vue?vue&type=template&id=ba16f8ce"
import script from "./confirm-modal.vue?vue&type=script&lang=js"
export * from "./confirm-modal.vue?vue&type=script&lang=js"
import style0 from "./confirm-modal.vue?vue&type=style&index=0&id=ba16f8ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports